import { Appeal } from '../../hot-alert/configurations/appeal';
import { Injectable } from "@angular/core";
import { Adapter } from "../../../records/classes/adapter";
import { Competitors } from './competitors';

import { CompetitorsPlanStatus } from './competitors-plan-status';

@Injectable({ providedIn: "root" })
export class CompetitorsAdapter extends Adapter<Competitors, any> {
  toView(plan: Competitors) {
    return new Competitors(plan);
  }

  generateDeleteBody(competitorsPlanData: Competitors) {
    let plan = {
      dealerId: competitorsPlanData.dealerId,
      competitors_businessId: competitorsPlanData.competitors_businessId,
      competitorsName: competitorsPlanData.competitorsName,
    };

    return plan;
  }

  generateCreateBody(formData: Competitors) {
    let plan = {
      dealerId: formData.dealerId,
      competitorsName: formData.competitorsName,
      enterpriseIdComp: formData.enterpriseIdComp,
      phone: formData.phone,
      zip: formData.zip,
      countryCode: formData.countryCode
    };

    return plan;
  }

}
